import React from "react";
import { Row, Col, Form, Input, Radio, Button, InputNumber, Select, message, Icon } from "antd";
import CompanyLosService from "./services/company-los-services";
import PropTypes from "prop-types";
import { GenericToolTip } from "../../components/genericTooltip";
import { ADD_COMMON_FORM } from "./constants/fields_info_json";

const MAX_ROI = 27.375;
class AddSubventionSchemeDetail extends React.Component {

    state = {
        margin: null,
        tenor: null,
        overdueTenor: null,
        normalRoi: null,
        minNormalRoi: null,
        maxNormalRoi: null,
        overdueRoi: null,
        roiStructure: "Flat",
        stopBillingApplicable: "No",
        stopBillingDays: null,
        coolingPeriod: null,
        cashbackApplicable: "Yes",
        dealerPerc: 100,
        sellerPerc: 0,
        disbursalWaitDays: null,
        subventionPerc: 0,
        subventionDays: null,
        subventionAmountPerUnit: null,
        count: 2,
        insertClick: null,
        insertAboveClick: false,
        insertBelowClick: false,
        error: null,
        isTieredAboveEdited: false,
        isTieredBelowEdited: false,
        tieredAboveArr: [],
        tieredBelowArr: [],
        showInsert: true,
        to_days1Err: false,
        from_days2Err: false,
        roi2Err: false,
        aboveT_err_msg: null,
        non_field_error: null,
        show_api_err: false,
        loading: false,
        lending_partner: null,
        progPerc: 0,
        subventionBy: "Seller",
        progcapSubventionDay: 0,
        anchorId: null,
        anchorUnitId: null,
        showDefaultConfirm : false,
        adhoc_roi_flat: {
            'adhoc_roi_1' : "",
            'adhoc_roi_2' : ""
        },
        adhocApplicableOnOverdue: false,
        additional_roi : ""
    }

    focusOutEvent = (errState, fieldName) => {
        if (this.state[errState]) {
            this.props.form.setFieldsValue({
                [fieldName]: ""
            });
            this.setState({
                [errState]: false
            });
        }
    }
    renderFlatTieredSection = () => {
        if (this.state.roiStructure == "Flat" && this.state.overdueTenor && this.state.minNormalRoi && this.state.overdueRoi) {
            return (
                <Col span={24}>
                    <Row className={"text-center mt-10"}>
                        <Col span={6}>
                            From Day: 1
                        </Col>
                        <Col span={6}>
                            To Day: {this.state.overdueTenor}
                        </Col>
                        <Col span={6}>
                            ROI: {this.state.normalRoi}
                        </Col>
                        <Col span={6}>
                            <InputNumber
                                min={0}
                                onChange={(val) => this.setState({
                                    adhoc_roi_flat :{
                                        ...this.state.adhoc_roi_flat,
                                        'adhoc_roi_1': val,
                                        'adhoc_roi_2': this.state.adhocApplicableOnOverdue ? val : this.state.adhoc_roi_flat['adhoc_roi_2']
                                    }
                                })}
                                value={this.state.adhoc_roi_flat.adhoc_roi_1}
                                placeholder="Adhoc ROI"
                                precision={3}
                                style={{ width: "80%" }}
                            />
                            {(this.state.adhoc_roi_flat.adhoc_roi_1 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_1 > (52 - this.state.minNormalRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}

                        </Col> 
                    </Row>
                    <Row className={"text-center"} style={{ marginTop: "20px", marginBottom: "20px" }}>
                        <Col span={6}>
                            From Day: {Number(this.state.overdueTenor) + 1}
                        </Col>
                        <Col span={6}>
                            To Day: 9999
                        </Col>
                        <Col span={6}>
                            ROI: {this.state.overdueRoi}
                        </Col>
                        <Col span={6}>
                            <InputNumber
                                min={0}
                                disabled
                                onChange={(val) => this.setState({
                                    adhoc_roi_flat :{
                                        ...this.state.adhoc_roi_flat,
                                        'adhoc_roi_2': val 
                                    }
                                })}
                                value={this.state.adhoc_roi_flat.adhoc_roi_2}
                                placeholder="Adhoc ROI"
                                precision={3}
                                style={{ width: "80%" }}
                            />
                            {(this.state.adhoc_roi_flat.adhoc_roi_2 > 52 || (this.state.adhoc_roi_flat.adhoc_roi_2 > (52 - this.state.overdueRoi)))  && <span className="input-err">{'Please enter correct value'}</span>}

                        </Col>
                    </Row>
                </Col>
            );
        }
    }

    focusOutEvent = (stateName, errorName) => {
        if (this.state[errorName]) {
            this.setState({
                [stateName]: null,
                [errorName]: false
            });
        } else {
            this.setState({
                [errorName]: false
            });
        }
    }

    fieldCheckValidations(item, value) {
        const { sellerPerc, dealerPerc } = this.state;
        this.setState({
            error: null,
            marginErr: false,
            tenorErr: false,
            normalRoiErr: false,
            overdueRoiErr: false,
            stopBillingDayErr: false,
            cpErr: false,
            dealerPerErr: false,
            sellerPerErr: false,
            progPerErr: false,
            subventionPercErr: false,
            disbursalWaitDaysErr: false,
            subventionDaysErr: false,
            subventionPerUnitErr: false,
        });
        if (item == "Margin") {
            if (value < 0 || value > 100) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    marginErr: true
                });
            }
            if (this.props.anchorList?.length == 1) {
                this.setState({
                    anchorId: this.props.anchorList[0].id
                });
            }
        }
        if (item == "Tenor") {
            if (value <= 0 || value > 365) {
                this.setState({
                    error: "Please enter correct value.",
                    tenorErr: true
                });
            } else {
                this.setState({
                    roiStructure: "Flat"
                });
                this.resetTiered();
            }
        }
        if (item == "Overdue ROI") {
            if (value < 0 || value > 100) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    overdueRoiErr: true,
                    roiStructure: "Flat"
                });
                this.resetTiered();
            } else if (value < this.state.maxNormalRoi || value == this.state.maxNormalRoi) {
                this.setState({
                    error: "Plese enter correct value.",
                    overdueRoiErr: true,
                    roiStructure: "Flat"
                });
                this.resetTiered();
            } 
        }
        if (item == "Stop Billing Days") {
            if (value <= 0) {
                this.setState({
                    error: "Value must be greater than 0",
                    stopBillingDayErr: true
                });
            } else if (value > this.state.overdueTenor) {
                this.setState({
                    error: "Value can't be greater than tenor day",
                    stopBillingDayErr: true
                });
            }
        }
        if (item == "Cooling Period") {
            if (value < 0) {
                this.setState({
                    error: "Value can't be less than 0",
                    cpErr: true
                });
            } else if (value > this.state.overdueTenor) {
                this.setState({
                    error: "Value can't be greater than tenor day",
                    cpErr: true
                });
            }
        }
        if (item == "Dealer Cashback %") {
            if (value < 0 || value > 100) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    dealerPerErr: true
                });
            } else {
                if (100 - sellerPerc - value > 0 || 100 - sellerPerc - value == 0) {
                    if (sellerPerc != 100) {
                        this.setState({
                            progPerc: (100 - sellerPerc - value).toFixed(2)
                        });
                    } else {
                        this.setState({
                            progPerc: 0
                        });
                    }
                } else {
                    this.setState({
                        error: "Value can't be less than 0 or greater than 100",
                        progPerErr: true,
                        progPerc: 0
                    });
                }
            }
        }
        if(item == "Subvention Amount Per Unit"){
            if(value<=0 || value> 100000){
                this.setState({
                    error:"Value can't be less than 0 or greater than 100000",
                    subventionPerUnitErr: true
                });
            }
        }
        if(item == "Subvention Days"){
            if(value >= this.state.overdueTenor || value <= 0){
                this.setState({
                    error:"Value can't be less than 0 or greater than tenor",
                    subventionDaysErr: true
                });
            }
        }
        if (item == "Seller Cashback %") {
            if (value < 0 || value > 100) {
                this.setState({
                    error: "Value can't be less than 0 or greater than 100",
                    sellerPerErr: true
                });
            } else {
                if (100 - dealerPerc - value > 0 || 100 - dealerPerc - value == 0) {
                    if (dealerPerc != 100) {
                        this.setState({
                            progPerc: (100 - dealerPerc - value).toFixed(2)
                        });
                    } else {
                        this.setState({
                            progPerc: 0
                        });
                    }
                } else {
                    this.setState({
                        error: "Value can't be less than 0 or greater than 100",
                        progPerErr: true,
                        progPerc: 0
                    });
                }
            }
        }
        if (item == "Disbursal wait days") {
            if (value > this.state.overdueTenor) {
                this.setState({
                    disbursalWaitDaysErr: true,
                    error: "Value can't be greater than tenor day."
                });
            }
        }
    }

    onSchemeAddClick = () => {
        const {
            progcapSubventionDay,
            margin,
            overdueTenor,
            minNormalRoi,
            maxNormalRoi,
            overdueRoi,
            stopBillingDays,
            coolingPeriod,
            dealerPerc,
            sellerPerc,
            progPerc,
            disbursalWaitDays,
            subventionPerc,
            subventionDays,
            subventionAmountPerUnit,
            additional_roi} = this.state;
        this.setState({
            show_api_err: false
        });
        const lending = this.props.isLendingScheme ? this.state.lending_partner : null;
        let roi_schedule = [
            {
                "from_days": 1,
                "to_days": overdueTenor,
                "roi": minNormalRoi,
                'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_1']
            },
            {
                "from_days": Number(overdueTenor) + 1,
                "to_days": 9999,
                "roi": overdueRoi,
                'adhoc_roi': this.state.adhoc_roi_flat['adhoc_roi_2']
            },
        ];
        let submitData = {
            "lending_partner": lending,
            "margin": margin,
            "tenor": overdueTenor,
            "overdue_tenor": overdueTenor,
            "min_min_normal_roi": Number(minNormalRoi),
            "min_normal_roi": Number(maxNormalRoi),
            "max_overdue_roi": Number(overdueRoi),
            "is_roi_structure_flat": true,
            "roi_schedule": roi_schedule,
            "stop_billing_days": stopBillingDays,
            "cooling_period": coolingPeriod,
            "cashback_sharing_percentage_for_dealer": dealerPerc != null ? dealerPerc.toFixed(2) : null,
            "cashback_sharing_percentage_for_seller": sellerPerc != null ? sellerPerc.toFixed(2) : null,
            "cashback_sharing_percentage_for_progcap": progPerc,
            "disbursal_wait_days": disbursalWaitDays,
            "subvention_perc": subventionPerc,
            "subvention_days": subventionDays,
            "subvention_per_unit": subventionAmountPerUnit,
            "progcap_subvention_days": progcapSubventionDay,
            "is_default_scheme": this.props.isDefaultScheme ? true : false,
            "scheme_type": 7,
            "anchor_id": this.props.anchorList && this.props.anchorList.length == 1 ? this.props.anchorList[0].id : this.state.anchorId,
            "unit_id": this.getAnchorUnitId(),
            "is_adhoc_applicable_on_overdue" : this.state.adhocApplicableOnOverdue,
            additional_roi
        };
        this.setState({
            loading: true
        });
        CompanyLosService.createNewScheme(this.props.companyId, submitData).then(({ data }) => {
            this.setState({
                loading: false,
                showDefaultConfirm : false
            });
            message.success("Scheme Created Successfully");
            this.props.onSuccess();
        }).catch((err) => {
            this.setState({
                loading: false,
                show_api_err: true,
                non_field_error: err.non_field_errors && err?.non_field_errors.length && err?.non_field_errors[0] || err[Object.keys(err)] && err[Object.keys(err)][0] || "Please enter correct data",
            });
        });
    }

    clearState() {
        this.setState({
            additional_roi : "",
            loading: false,
            lending_partner: null,
            margin: null,
            tenor: null,
            overdueTenor: null,
            normalRoi: null,
            overdueRoi: null,
            roiStructure: "Flat",
            stopBillingApplicable: "No",
            stopBillingDays: null,
            coolingPeriod: null,
            cashbackApplicable: "Yes",
            dealerPerc: 100,
            sellerPerc: 0,
            progPerc: 0,
            disbursalWaitDays: null,
            subventionPerc: 0,
            subventionDays: 0,
            count: 2,
            insertClick: null,
            insertAboveClick: false,
            insertBelowClick: false,
            error: null,
            isTieredAboveEdited: false,
            isTieredBelowEdited: false,
            tieredAboveArr: [],
            tieredBelowArr: [],
            showInsert: true,
            to_days1Err: false,
            from_days2Err: false,
            roi2Err: false,
            aboveT_err_msg: null,
            non_field_error: null,
            show_api_err: false,
            subventionBy: "Seller",
            progcapSubventionDay: 0,
            subventionAmountPerUnit: null,
            minNormalRoi: null,
            maxNormalRoi: null,
            anchorUnitId: null,
        });
        this.props.stateCleared();
    }

    setFlatRoiStr(item) {
        this.setState({
            roiStructure: item.target.value,
            adhoc_roi_flat : {
                ...this.state.adhoc_roi_flat,
                'adhoc_roi_1' : MAX_ROI - this.state.normalRoi,
                'adhoc_roi_2' : 0
            },
            additional_roi : this.state.overdueRoi - this.state.minNormalRoi 

        });
        this.resetTiered();
    }

    resetTiered() {
        this.setState({
            adhoc_roi_flat: {
                'adhoc_roi_1' : "",
                'adhoc_roi_2' : ""
            },
            tieredAboveArr: [],
            tieredBelowArr: [],
            isTieredBelowEdited: true,
            isTieredAboveEdited: true,
            showInsert: true
        });
    }

    onChange(value) {
        this.setState({
            lending_partner: value
        });
    }
    getAnchorUnitId = () => {
        return (this.props.anchorList && this.props.anchorList.length == 1 && this.props.anchorList[0]?.units && this.props.anchorList[0]?.units.length == 1) || (this.state.anchorId && this.props.anchorList.find(el=>this.state.anchorId === el.id)?.units.length ==1) ? (this.state.anchorId && this.props.anchorList.find(el=>this.state.anchorId === el.id)?.units[0].unit_id) || (this.props.anchorList[0] && this.props.anchorList[0].units[0] && this.props.anchorList[0].units[0].unit_id) : this.state.anchorUnitId;
    } 
    getAnchorUnit = () => {
        const filterAnchor = this.props.anchorList.filter(_ => _.id == this.state.anchorId);
        return filterAnchor[0].units.length == 1 ? filterAnchor[0].units[0].name : filterAnchor[0].units.filter(_ => _.unit_id == this.state.anchorUnitId)[0].name;
    }

    render() {
        if (this.props.clearState) {
            this.clearState();
        }
        return (
            <Row gutter={24}>
                <Col>
                    <Form>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>Anchor <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor")} /></span>} required={true} style={{ margin: "0" }}>
                                    {
                                        this.props.anchorList && this.props.anchorList.length == 1 ? <Input style={{ width: "70%" }} value={this.props.anchorList[0].short_name} disabled={true} /> : <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select Anchor"
                                            optionFilterProp="children"
                                            onChange={(val) => this.setState({ anchorId: val })}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.anchorList && this.props.anchorList.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.id} key={k}>{item.short_name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    }
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Unit <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("anchor_unit")} /></span>} required={true} style={{ margin: "0" }}>
                                    {
                                        (this.props.anchorList && this.props.anchorList.length == 1 && this.props.anchorList[0]?.units && this.props.anchorList[0]?.units.length == 1 ||  this.props.anchorList?.find(el=>this.state.anchorId === el.id)?.units.length ==1) ? <Input style={{ width: "60%" }} value={this.props.anchorList.find(el=>this.state.anchorId === el.id)?.units[0].name || this.props.anchorList[0].units[0] && this.props.anchorList[0].units[0].name } disabled={true} /> : <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select Unit"
                                            optionFilterProp="children"
                                            onChange={(val) => this.setState({ anchorUnitId: val})}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.anchorList && this.props.anchorList.find(el=>this.state.anchorId === el.id)?.units && this.props.anchorList.find(el=>this.state.anchorId === el.id)?.units.map((item) => {
                                                return (
                                                    <Select.Option value={item.unit_id} key={item.unit_id}>{item.name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            this.props.isLendingScheme ? <Row style={{ marginBottom: "20px" }}>
                                <Col>
                                    <Form.Item label="Partner Bank" required={true} style={{ margin: "0" }}>
                                        <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select lending partner"
                                            optionFilterProp="children"
                                            onChange={(val) => this.onChange(val)}
                                            onSearch={(val) => this.onSearch(val)}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {this.props.partnerbank && this.props.partnerbank.map((item, k) => {
                                                return (
                                                    <Select.Option value={item.id} key={k}>{item.name}</Select.Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row> : null
                        }
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>Margin <GenericToolTip toolTipData={<Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />} tooltipText={ADD_COMMON_FORM.get("margin")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber style={{ width: "100%" }} precision={2} type={"number"} value={this.state.margin} min={0} max={100} onChange={(item) => this.setState({ margin: item }, this.fieldCheckValidations("Margin", item))} />
                                </Form.Item>
                                {this.state.marginErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={6} style={{ margin: "0px 10px" }}>
                                <Form.Item label={<span>Tenor (days) <GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("tenor")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.overdueTenor} onChange={(item) => this.setState({ overdueTenor: item, progcapSubventionDay: 0 }, this.fieldCheckValidations("Tenor", item))} />
                                </Form.Item>
                                {this.state.tenorErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Overdue Tenor (days)<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("overdue_tenor")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.overdueTenor} className={"read-only-input"} onChange={(item) => this.setState({ overdueTenor: item })} readOnly />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>Min Normal ROI <GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("min_normal_roi")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber 
                                        style={{ width: "100%" }} 
                                        value={this.state.minNormalRoi} 
                                        precision={3} 
                                        onChange={(item) => this.setState({
                                             minNormalRoi: item, 
                                             additional_roi: (this.state.overdueRoi -  item).toFixed(3),
                                             overdueRoi: "",
                                             maxNormalRoi: "",
                                             adhocApplicableOnOverdue: false,
                                             adhoc_roi_flat: {
                                                'adhoc_roi_1' : "",
                                                'adhoc_roi_2' : ""
                                            },
                                        })
                                        } 
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={7} style={{ margin: "0px 10px" }}>
                                <Form.Item label={<span>Max Normal ROI <GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("max_normal_roi")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber 
                                        style={{ width: "100%" }} 
                                        value={this.state.maxNormalRoi} precision={3} 
                                        onChange={(item) => this.setState({ maxNormalRoi: item })} 
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Overdue ROI<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("overdue_roi")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber 
                                        precision={3} 
                                        style={{ width: "100%" }} 
                                        value={this.state.overdueRoi} 
                                        onChange={(item) => this.setState({
                                            overdueRoi: item, 
                                            additional_roi: (item - this.state.minNormalRoi).toFixed(3),
                                            adhoc_roi_flat : {
                                                ...this.state.adhoc_roi_flat,
                                                'adhoc_roi_1' : MAX_ROI - this.state.minNormalRoi,
                                                'adhoc_roi_2' : 0
                                            },
                                            adhocApplicableOnOverdue: false,
                                        }, this.fieldCheckValidations("Overdue ROI", item))} />
                                </Form.Item>
                                {this.state.overdueRoiErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col span={5}>
                                <Form.Item label={<span>Is Adhoc Applicable On Overdue</span>}>
                                    <Radio.Group value={this.state.adhocApplicableOnOverdue}>
                                        <Radio.Button onChange={(item) => {
                                             
                                            this.setState({ 
                                                adhocApplicableOnOverdue: true,
                                                adhoc_roi_flat : {
                                                    ...this.state.adhoc_roi_flat,
                                                    'adhoc_roi_2': this.state.adhoc_roi_flat['adhoc_roi_1'] 
                                                }})
                                            }} value={true}>Yes</Radio.Button>
                                        <Radio.Button onChange={(item) => {
                                            this.setState({ 
                                                adhocApplicableOnOverdue: false,
                                                adhoc_roi_flat : {
                                                    ...this.state.adhoc_roi_flat,
                                                    'adhoc_roi_2': 0 
                                                }
                                             })
                                        }} value={false}>No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>ROI Structure<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("roi_structure")} /></span>} name="roiStructure" required={true} style={{ margin: "0" }}>
                                    <Radio.Group value={this.state.roiStructure}>
                                        <Radio.Button onChange={(item) => this.setFlatRoiStr(item)} default value={"Flat"}>Flat</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col style={{ marginTop: "20px" }}>
                                {this.renderFlatTieredSection()}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7} style={{ marginLeft: "10px" }}>
                                <Form.Item label={<span>Actual Overdue ROI</span>}>
                                    <InputNumber disabled style={{ width: "100%" }} onChange={(item) => this.setState({
                                        additional_roi: item
                                    })} value={ this.state.additional_roi } />
                                    {(this.state.additional_roi < 0 || this.state.additional_roi > this.state.overdueRoi)  && <span style={{fontSize: "11px", color: "red"}}>Value cannot be less than 0 or greter than Overdue ROI</span>}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={7}>
                                <Form.Item label={<span>Stop Billing Applicable<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("stop_billing_applicable")} /></span>} name="stopBillingApplicable" required={true} style={{ margin: "0" }}>
                                    <Radio.Group value={this.state.stopBillingApplicable}>
                                        <Radio.Button onChange={(item) => this.setState({ stopBillingApplicable: item.target.value })} value="Yes">Yes</Radio.Button>
                                        <Radio.Button onChange={(item) => this.setState({ stopBillingApplicable: item.target.value, stopBillingDays: null })} value="No">No</Radio.Button>
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col span={6} style={{ margin: "0px 10px" }}>
                                <Form.Item label={<span>Stop Billing Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("stop_billing_days")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.stopBillingDays} className={this.state.stopBillingApplicable == "No" ? "read-only-input" : null} onChange={(item) => this.setState({ stopBillingDays: item }, this.fieldCheckValidations("Stop Billing Days", item))} readOnly={this.state.stopBillingApplicable == "No" ? true : false} />
                                </Form.Item>
                                {this.state.stopBillingDayErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={7}>
                                <Form.Item label={<span>Cooling Period<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("cooling_period")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber style={{ width: "100%" }} value={this.state.coolingPeriod} onChange={(item) => this.setState({ coolingPeriod: item }, this.fieldCheckValidations("Cooling Period", item))} />
                                </Form.Item>
                                {this.state.cpErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                        </Row>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={5} style={{ margin: "0px 10px" }}>
                                <Form.Item label={<span>Dealer Cashback %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("dealer_perc")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber precision={2} style={{ width: "100%" }} value={this.state.dealerPerc} onChange={(item) => this.setState({ dealerPerc: item }, this.fieldCheckValidations("Dealer Cashback %", item))} className={this.state.cashbackApplicable == "No" ? "read-only-input" : null} readOnly={this.state.cashbackApplicable == "No" ? true : false} />
                                </Form.Item>
                                {this.state.dealerPerErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={5} style={{ margin: "0px 10px" }}>
                                <Form.Item label={<span>Seller Cashback %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("seller_perc")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber precision={2} style={{ width: "100%" }} value={this.state.sellerPerc} onChange={(item) => this.setState({ sellerPerc: item }, this.fieldCheckValidations("Seller Cashback %", item))} className={this.state.cashbackApplicable == "No" ? "read-only-input" : null} readOnly={this.state.cashbackApplicable == "No" ? true : false} />
                                </Form.Item>
                                {this.state.sellerPerErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            <Col span={5}>
                                <Form.Item label={<span>Progcap Cashback %<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("progcap_perc")} /></span>} required={true} style={{ margin: "0" }}>
                                    <InputNumber readOnly={true} onBlur={() => this.focusOutEvent("progPerc", "progPerErr")} precision={2} style={{ width: "100%" }} value={this.state.progPerc} onChange={(item) => this.setState({ progPerc: item }, this.fieldCheckValidations("Progcap %", item))} className={"read-only-input"} />
                                </Form.Item>
                                {this.state.progPerErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                            </Col>
                            
                        </Row>
                        {
                            <Row style={{ marginBottom: "20px" }}>
                                <Col span={5} style={{ margin: "0px 10px" }}>
                                    <Form.Item label={<span>Disbursal Wait Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("disbursal_wait_days")} /></span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber style={{ width: "100%" }} value={this.state.disbursalWaitDays} onChange={(item) => this.setState({ disbursalWaitDays: item }, this.fieldCheckValidations("Disbursal wait days", item))}/>
                                    </Form.Item>
                                    {this.state.disbursalWaitDaysErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                </Col>
                                <Col span={5} style={{ margin: "0px 10px" }}>
                                    <Form.Item label={<span>Subvention Days<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("subvention_days")} /></span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber style={{ width: "100%" }} value={this.state.subventionDays} onChange={(item) => this.setState({ subventionDays: item }, this.fieldCheckValidations("Subvention Days", item))} />
                                    </Form.Item>
                                    {this.state.subventionDaysErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                </Col>
                                <Col span={5} style={{ margin: "0px 10px" }}>
                                    <Form.Item label={<span>Subvention Amount Per Unit<GenericToolTip toolTipData={<Icon type="info-circle" style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} />} tooltipText={ADD_COMMON_FORM.get("subvention_amount_per_unit")} /></span>} required={true} style={{ margin: "0" }}>
                                        <InputNumber precision={2} style={{ width: "100%" }} value={this.state.subventionAmountPerUnit} onChange={(item) => this.setState({ subventionAmountPerUnit: item }, this.fieldCheckValidations("Subvention Amount Per Unit", item))} />
                                    </Form.Item>
                                    {this.state.subventionPerUnitErr && <span style={{ fontSize: "11px", color: "red" }}>{this.state.error}</span>}
                                </Col>
                            </Row>
                        }
                        <Row>
                            {
                                this.state.show_api_err ? <Col className={"m-5"}>
                                    <span className={"error-text"}>* {this.state.non_field_error}</span>
                                </Col> : null
                            }
                            <Col span={7}>
                                <Button onClick={() => this.setState({showDefaultConfirm: true})} loading={this.state.loading}
                                    className={"ant-btn ant-btn-primary"}>Submit</Button>
                            </Col>
                            
                        </Row>
                        {!Object.values(this.state.adhoc_roi_flat).some(x => x === null || x === '') && 
                        (this.state.additional_roi > 0 && this.state.additional_roi < this.state.overdueRoi)  && this.state.showDefaultConfirm && this.state.subventionDays && this.state.subventionAmountPerUnit && this.state.anchorId && this.state.minNormalRoi && this.state.maxNormalRoi && <Row style={{marginTop: "20px"}}>
                            <p style={{color: "red", fontWeight: "bold"}}>As per above parameters, price of {this.getAnchorUnit()} can vary from {(((365*this.state.subventionAmountPerUnit)/(this.state.minNormalRoi * this.state.subventionDays))*100).toFixed(2)} to {(((365*this.state.subventionAmountPerUnit)/(this.state.maxNormalRoi * this.state.subventionDays))*100).toFixed(2)}</p>
                            <p style={{color: "red", fontWeight: "bold"}}>Are you sure?</p>
                            <Col>
                                {
                                    this.state.show_api_err?<Col className={"m-5"}>
                                        <span className={"error-text"}>* {this.state.non_field_error}</span>
                                    </Col>:null
                                }
                                <Button style={{ marginTop: "20px" }} onClick={() => this.onSchemeAddClick()} loading={this.state.editLoading} className={"ant-btn ant-btn-primary"}>Yes</Button>
                                <Button style={{ marginTop: "20px", marginLeft: "20px" }} onClick={() => this.setState({showDefaultConfirm: false})} className={"ant-btn ant-btn-primary"}>No</Button>
                            </Col>
                        </Row>
                        }
                    </Form>
                </Col>
            </Row>
        );
    }
}

AddSubventionSchemeDetail.propTypes = {
    form: PropTypes.object,
    companyId: PropTypes.string,
    isDefaultScheme: PropTypes.bool,
    isLendingScheme: PropTypes.bool,
    clearState: PropTypes.bool,
    stateCleared: PropTypes.func,
    partnerbank: PropTypes.array,
    onSuccess: PropTypes.func,
    anchorList: PropTypes.array,
};

export default Form.create({})(AddSubventionSchemeDetail);